import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { complexesUrl } from "@/lib/translations";
import { ComplexCard } from "@/components/ComplexCard";

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

/** „Fincas & Anlagen auf {Insel}“ bzw. „… in {Ort}“ – nur sichtbar, wenn es passende aktive Anlagen gibt. */
export const ComplexesSection = ({ island, place, heading, testId = "complexes-section" }) => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!island) return;
    api.get("/complexes", { params: { island } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [island]);
  const list = place ? items.filter((c) => norm(c.location) === norm(place)) : items;
  if (!list.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-16" data-testid={testId}>
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-brand mb-2">{t.complex.breadcrumb}</div>
          <h2 className="font-serif text-2xl md:text-3xl text-stone-900">{heading}</h2>
          <p className="text-sm text-stone-600 mt-1">{t.complex.sectionIntro}</p>
        </div>
        <Link to={complexesUrl()} className="inline-flex items-center gap-1.5 text-sm text-brand font-semibold hover:gap-2.5 transition-all" data-testid={`${testId}-all`}>{t.complex.overviewTitle}<ArrowRight className="w-4 h-4" /></Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {list.map((c) => <ComplexCard key={c.id} complex={c} showIsland={false} />)}
      </div>
    </section>
  );
};
